import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { deleteView, listViews, saveView, type SavedView } from '../lib/savedViews.js';

/** Save/restore filter combinations (deep-link query) locally (§10). */
export function SavedViews() {
  const [sp, setSp] = useSearchParams();
  const [views, setViews] = useState<SavedView[]>(() => listViews());
  const [name, setName] = useState('');

  function save() {
    if (!name.trim()) return;
    setViews(saveView(name, sp.toString()));
    setName('');
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {views.map((v) => (
        <span
          key={v.name}
          className="inline-flex items-center gap-1 rounded-full border border-slate-700 bg-slate-900 px-2 py-1 text-xs text-slate-300"
        >
          <button
            onClick={() => setSp(new URLSearchParams(v.query), { replace: true })}
            className="hover:text-blue-300"
          >
            {v.name}
          </button>
          <button
            onClick={() => setViews(deleteView(v.name))}
            className="text-slate-500 hover:text-rose-400"
            title="Eliminar vista"
          >
            ✕
          </button>
        </span>
      ))}
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Guardar vista…"
        className="w-32 rounded-md border border-slate-700 bg-slate-900 px-2 py-1 text-xs text-slate-100"
      />
      <button
        onClick={save}
        className="rounded-md bg-slate-700 px-2 py-1 text-xs text-slate-200 hover:bg-slate-600"
      >
        Guardar
      </button>
    </div>
  );
}
